// React není potřeba pro tento komponent

export function Toaster() {
  return (
    <div
      id="toast-container"
      className="fixed top-0 right-0 z-50 p-4 space-y-2"
    >
      {/* Toast notifications will be rendered here */}
    </div>
  )
} 